import { useEffect, useState } from "react";
import gql from "graphql-tag";
import { useApolloClient } from "@apollo/client";
import { emptyArray } from "constants/defaultValues";
import { v4 as uuidv4 } from "uuid";

const query = gql`
  query applicationLoader {
    applicationLoader {
      components {
        id
        loading
      }
    }
  }
`;

export const useLoaderEffect = (loading = false) => {
  const [showApplicationLoader, setShowApplicationLoader] = useState(loading);
  const [componentId] = useState(uuidv4());
  const client = useApolloClient();

  useEffect(() => {
    const data = client.cache.readQuery({ query });
    const component = (data?.applicationLoader?.components || emptyArray).filter((x) => x.id === componentId);

    if ((!component && loading) || component.loading !== loading) {
      const components = (data?.applicationLoader?.components || emptyArray).filter((x) => x.id !== componentId);
      client.cache.writeQuery({
        query,
        data: {
          applicationLoader: {
            __typename: "ApplicationLoader",
            components: [
              ...components,
              { __typename: "ComponentWithApplicationLoader", id: componentId, loading: loading },
            ],
          },
        },
      });
    }

    return () => {
      const data = client.cache.readQuery({ query });
      const components = (data?.applicationLoader?.components || emptyArray).filter((x) => x.id !== componentId);
      client.cache.writeQuery({
        query,
        data: { applicationLoader: { __typename: "ApplicationLoader", components: [...components] } },
      });
    };
  }, [componentId, loading, client]);

  useEffect(() => {
    const subscription = client.watchQuery({ query, fetchPolicy: "cache-only" }).subscribe({
      next: ({ data }) => {
        const showApplicationLoader =
          (data?.applicationLoader?.components || emptyArray).findIndex((x) => x.loading) > -1;
        setShowApplicationLoader(showApplicationLoader);
      },
    });

    return () => subscription.unsubscribe();
  }, [client]);

  return showApplicationLoader;
};
